import Experience from '../Experience.js'
import Environment from './Environment.js'
import Workspace from './Workspace.js'

export default class World {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        // Wait for resources
        this.resources.on('ready', () => {
            // Setup
            this.workspace = new Workspace()
            this.environment = new Environment()
        })
    }

    update() {
        if (this.fox) this.fox.update()
    }
}
